<template>
  <div class="refundHeader">
    <div class="header">
      <img src="@/assets/images/home/logo1.png" alt="" />
      <h2>退款申请</h2>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.refundHeader {
  padding-bottom: 15px;
  border-bottom: 2px solid #377cf1;
  margin-top: 90px;
  .header {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    h2 {
      height: 40px;
      font-size: 20px;
      font-weight: 600;
      color: #555555;
      padding-top: 15px;
      padding-left: 34px;
    }
  }
}
</style>